export class ConcreteMixture {
    _id?: string;
    name?: string;
    concreteType?: string;
    plant?: string;
    project?: string;
    company?: string;
    fck?: number;
    isCertified?: boolean;
    certificationLevel?: string;
    certificationDispersionValue?: number;
    theoreticalCementContent?: number;
    theoreticalWaterCementRatio?: number;
    updatedAt?: Date;
    createdAt?: Date;
  }
